import React from 'react'
import Layout from 'features/layout/components/Layout'
import RibbonItem from '../components/RibbonItem'

const RibbonItemPage = (props) => {
  return (
    <Layout>
      <RibbonItem />
    </Layout>
  )
}

export default RibbonItemPage
